// removed by extract-text-webpack-plugin
module.exports = {"appBar":"feature__appBar___1GfwZ","leftIcon":"feature__leftIcon___1s6f_","link":"feature__link___17O3D","action":"feature__action___3x5M_","yes":"feature__yes___hSOLA","no":"feature__no___2MSTG"};


//////////////////
// WEBPACK FOOTER
// ./src/component/feature/feature.scss
// module id = 374
// module chunks = 0